import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { track } from '../../../helpers';
import { ChevronNextIcon } from '../../shared/SvgIcons';

import styles from './carousel.scss';

/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-no-bind */

export class NextArrow extends React.Component {
    render() {
        const divProps = Object.assign({}, this.props);

        // delete props inherited from react Slider
        const unwantedProps = ['styles', 'currentSlide', 'slideCount'];
        unwantedProps.map((propName) => delete divProps[propName]);

        return (
            <div {...divProps}>
                <a onClick={() => track('reco_ca_arrow_next')} styleName="next-arrow-link">
                    <ChevronNextIcon styleName="icon" direction="right" />
                </a>
            </div>
        );
    }
}

NextArrow.propTypes = {
    styles: PropTypes.object,
    currentSlide: PropTypes.number,
    slideCount: PropTypes.number
};

export default CSSModules(NextArrow, styles, { allowMultiple: true });
